import { render, staticRenderFns } from "./TesseractIconBlack.vue?vue&type=template&id=953be020&"
import script from "./TesseractIconBlack.vue?vue&type=script&lang=js&"
export * from "./TesseractIconBlack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports